<ng-container>
    <div class="comp_guidelines_block k-p-2 k-container">
       <div class="k-container-fluid">
        <div class="k-row">
            <!-- heading -->
            <div class="title_heading">
                <h1>Compatibility Guidelines</h1>
            </div>
        </div> 
         <!-- content -->
        <div class="k-w-full k-d-grid k-grid-cols-6 k-gap-1">
            <!-- fileupload -->
             <div class="'fileupload_block k-col-span-2">
                <p class="title-section k-text-uppercase k-text-secondary"> File upload  </p>
                
                <div class="UploadWrapper k-rounded-md">
                    <form  [formGroup]="frmUploadItems" (ngSubmit)="onSubmit()" >
                        <kendo-label class="upload_lable">
                            <div class="upload-container k-rounded-md" (click)="triggerFileInput()" >
                                <input formControlName='file' type="file" accept="application/pdf" id="fileInput" class="k-d-none" (change)="onFileSelect($event)" >
                                <span>Choose File</span>
                                <label>{{fileName}} </label>
                            </div>
                        </kendo-label>
                        <kendo-label class="k-display-block" [for]="Notes" text="Notes"></kendo-label>
                        <kendo-textarea  formControlName="note" #Notes [rows]="3" [disabled]="readonlyNote"  
                        (valueChange)="onChangenote()"></kendo-textarea>

                        <div class="btn-block k-text-align-righ k-d-flex k-justify-content-end">  
                            <input type="submit" value="Save" class="btn_save k-btn-primary k-button-lg" [ngClass]="showButton?'k-display-none':'k-display-block'"> 
                        
                            <input type="reset" value="Reset" class="btn_reset k-button-lg k-pointer-events-auto" (click)="resetForm()" >                             
                        </div>
                    </form>
                </div>
             </div>
        
             <!-- table record -->
           
            <div class="comp_guidelines_table k-col-span-4">
              <div class="col-xs-12 col-md-6">
                <kendo-grid class="mt-10" [data]="compGuidelinesList" [sortable]="true" [resizable]="true"> 
                    
                    <kendo-grid-column  title="" [width]="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="fa fa-fw fa-file-pdf fa-lg"></span>
                            </ng-template>
                    </kendo-grid-column>

                  <kendo-grid-column  title="FILE NAME" field="fileName" [width]="150">
                    <ng-template  kendoGridCellTemplate let-dataItem >
                        <a class="k-font-size-md" download [ngClass]="{'click':true}" (click)="getAttachments(dataItem)">
                            {{dataItem.fileName}} </a>
                    </ng-template>
                </kendo-grid-column>

                  <kendo-grid-column  title="USERNAME" field="username" [width]="150">
                      <ng-template  kendoGridCellTemplate let-dataItem>
                          <span class="k-font-size-md">{{dataItem.userName}} </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="DATE / TIME" field="dateTime" [width]="200">
                    <ng-template  kendoGridCellTemplate let-dataItem>
                        <span class="k-font-size-md"  [ngClass]="{'date-view':true}"> {{ dataItem.createdOn | dateFormatter:'dd MMM YYYY hh:mm a' }} </span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column class="k-font-size-md" title="NOTES" field="notes" [width]="150"></kendo-grid-column>
                  <kendo-grid-column title="" [width]="40">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <fa-icon class="k-font-size-lg delet-btn"[ngClass]="{'click':true}" [icon]="iconPacks.FAFILEDELETE"
                              (click)="deleteCompatibilityGuidelines(dataItem.id,dataItem.fileName)"></fa-icon>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
            </div>
            </div>
        </div>
    </div>
    </div>
</ng-container>